import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PermissionEditor = _resolveComponent("PermissionEditor")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PermissionEditor, {
      "display-name": $options.displayName,
      permissions: $options.permissions,
      onClose: _cache[0] || (_cache[0] = $event => (_ctx.$emit('close'))),
      onSubmit: $options.handleSubmitPermissions
    }, null, 8, ["display-name", "permissions", "onSubmit"])
  ]))
}